import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=448ba064&scoped=true&"
import script from "./AboutUsView.vue?vue&type=script&lang=js&"
export * from "./AboutUsView.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=448ba064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ba064",
  null
  
)

export default component.exports